import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, renderList as _renderList } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex flex-1 items-center justify-center text-[11px] text-slate-300"
};
const _hoisted_2 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_3 = {
  class: "truncate text-xs font-medium text-slate-700"
};
const _hoisted_4 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_5 = {
  class: "text-slate-700"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
  class: "flex items-start justify-between gap-1"
};
const _hoisted_8 = {
  class: "min-w-0 flex-1"
};
const _hoisted_9 = {
  class: "truncate text-sm font-semibold text-slate-900"
};
const _hoisted_10 = {
  class: "mt-0.5 flex flex-wrap items-center gap-1 text-[11px]"
};
const _hoisted_11 = {
  key: 0,
  class: "status-badge is-neutral"
};
const _hoisted_12 = {
  key: 1,
  class: "status-badge is-warning"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
  key: 0,
  class: "text-[11px] font-medium text-red-600"
};
const _hoisted_15 = {
  class: "flex items-baseline gap-1.5 text-xs"
};
const _hoisted_16 = {
  class: "font-medium text-slate-700"
};
const _hoisted_17 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_18 = {
  class: "flex items-baseline gap-2 text-[11px] text-slate-500"
};
const _hoisted_19 = {
  class: "ml-1 font-medium text-slate-700"
};
const _hoisted_20 = {
  class: "truncate text-[11px] text-slate-400"
};
const _hoisted_21 = {
  key: 0,
  class: "ml-1 rounded bg-amber-100 px-1 py-0.5 text-[10px] font-medium text-amber-700",
  title: "R_PRODUCT_NAME_NOT_MATCHED"
};
const _hoisted_22 = {
  class: "mt-auto flex flex-wrap gap-1"
};
const _hoisted_23 = ["disabled", "title", "onClick"];
import { computed } from 'vue';
import { ArrowPathIcon } from '@heroicons/vue/24/outline';
import { formatInvoiceAmount, formatInvoiceAmountTo, formatProfitRate } from '../utils';
export default {
  __name: 'InvoiceChainMatrixCell',
  props: {
    node: {
      type: Object,
      default: null
    },
    regionName: {
      type: String,
      default: ''
    },
    issueMark: {
      type: Object,
      default: null
    },
    edgeProductName: {
      type: String,
      default: ''
    },
    edgeProductMatched: {
      type: Boolean,
      default: true
    },
    edgeProductItems: {
      type: Array,
      default: () => []
    },
    syncing: {
      type: Boolean,
      default: false
    },
    isPlatform: {
      type: Boolean,
      default: false
    },
    canRerankAfter: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit', 'toggle-lock', 'regenerate-after'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const companyName = computed(() => {
      const node = props.node;
      if (!node) return '';
      return node.effectiveCompanyName || node.companyNameSnapshot || node.companyName || '-';
    });
    const platformName = computed(() => props.node?.effectiveCompanyName || '平台');
    const inputAmount = computed(() => props.node?.effectiveInputAmount ?? props.node?.inputAmount ?? null);
    const outputAmount = computed(() => props.node?.effectiveOutputAmount ?? props.node?.outputAmount ?? null);
    const profitRate = computed(() => props.node?.effectiveProfitRate ?? props.node?.profitRate ?? null);

    // 利润金额 = 销项 - 进项；税额 = 销项*0.06 - 进项*0.06（= 利润金额 * 0.06）
    const profitAmount = computed(() => {
      const input = Number(inputAmount.value);
      const output = Number(outputAmount.value);
      if (!Number.isFinite(input) || !Number.isFinite(output)) return null;
      return output - input;
    });
    const taxAmount = computed(() => {
      const profit = profitAmount.value;
      if (profit === null || !Number.isFinite(profit)) return null;
      return profit * 0.06;
    });
    const formattedEdgeProductItems = computed(() => formatEdgeProductItems(props.edgeProductItems));
    const edgeProductUnmatched = computed(() => props.edgeProductMatched === false || props.edgeProductItems.some(item => item?.matched === false || item?.productNameMatched === false));
    const displayedEdgeProductName = computed(() => formattedEdgeProductItems.value || props.edgeProductName || props.node?.productName || '—');
    const isHundredPercent = computed(() => {
      const rate = Number(profitRate.value);
      if (!Number.isFinite(rate)) return false;
      return Number(rate.toFixed(6)) === 1;
    });
    const lockChips = computed(() => {
      const node = props.node || {};
      return [{
        key: 'companyLocked',
        label: '公',
        locked: Boolean(node.companyLocked),
        title: '锁定公司'
      }, {
        key: 'inputAmountLocked',
        label: '进',
        locked: Boolean(node.inputAmountLocked),
        title: '锁定进项'
      }, {
        key: 'outputAmountLocked',
        label: '出',
        locked: Boolean(node.outputAmountLocked),
        title: '锁定销项'
      }, {
        key: 'profitRateLocked',
        label: '利',
        locked: Boolean(node.profitRateLocked),
        title: '锁定利润率'
      }, {
        key: 'productNameLocked',
        label: '品',
        locked: Boolean(node.productNameLocked),
        title: '锁定品名'
      }];
    });
    const cellClass = computed(() => {
      if (!props.node) return ['border border-dashed border-slate-200 bg-slate-50/30'];
      const classes = ['border cursor-default transition-colors hover:bg-slate-50/60'];
      if (props.issueMark?.hasError) {
        classes.push('border-red-300 bg-red-50/50');
      } else if (props.issueMark?.hasWarning || edgeProductUnmatched.value) {
        classes.push('border-amber-300 bg-amber-50/40');
      } else if (props.node.invalidReason) {
        classes.push('border-red-200 bg-red-50/30');
      } else if (props.isPlatform) {
        classes.push('border-indigo-200 bg-indigo-50/30');
      } else {
        classes.push('border-slate-200 bg-white');
      }
      return classes;
    });
    function formatEdgeProductItems(items = []) {
      return (items || []).map(item => {
        const rawName = item?.productName || item?.productNames || '';
        const name = Array.isArray(rawName) ? rawName.join('/') : String(rawName || '').trim();
        if (!name) return '';
        const amount = item?.invoiceAmount ?? item?.amount ?? item?.displayAmount;
        const amountText = formatInvoiceAmount(amount);
        return amountText === '-' ? name : `${name} ${amountText}`;
      }).filter(Boolean).join('、');
    }
    function onCellClick() {
      if (props.syncing || !props.node || props.isPlatform) return;
      emit('edit');
    }
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([cellClass.value, "relative flex h-full min-h-[112px] flex-col gap-1 px-2 py-1.5 text-left"]),
        onClick: onCellClick
      }, [!__props.node ? (_openBlock(), _createElementBlock("div", _hoisted_1, "—")) : __props.isPlatform ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "inline-block h-3 w-1 rounded-full bg-indigo-500"
      }, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "status-badge is-indigo"
      }, "平台", -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(platformName.value), 1)]), _createElementVNode("div", _hoisted_4, [_cache[4] || (_cache[4] = _createTextVNode(" 品名：", -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(displayedEdgeProductName.value), 1)]), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: _normalizeClass(["lock-chip mt-auto", __props.node.productNameLocked ? 'is-locked' : 'is-unlocked']),
        disabled: __props.syncing,
        title: "锁定品名",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => emit('toggle-lock', 'productNameLocked'), ["stop"]))
      }, [...(_cache[5] || (_cache[5] = [_createTextVNode("品", -1)]))], 10, _hoisted_6)), [[_directive_permission, 'enterprise-invoice:chain:lock']])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(companyName.value), 1), _createElementVNode("div", _hoisted_10, [__props.regionName ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(__props.regionName), 1)) : _createCommentVNode("", true), isHundredPercent.value ? (_openBlock(), _createElementBlock("span", _hoisted_12, "100%")) : _createCommentVNode("", true)])]), __props.canRerankAfter ? _withDirectives((_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "table-action-button is-purple shrink-0",
        title: "从此节点后重排",
        "aria-label": "从此节点后重排",
        disabled: __props.syncing,
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => emit('regenerate-after'), ["stop"]))
      }, [_createVNode(_unref(ArrowPathIcon), {
        class: "h-3.5 w-3.5"
      })], 8, _hoisted_13)), [[_directive_permission, 'enterprise-invoice:chain:generate']]) : _createCommentVNode("", true)]), __props.node.invalidReason ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(__props.node.invalidReason), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "text-[10px] uppercase tracking-wide text-slate-400"
      }, "进", -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(formatInvoiceAmount)(inputAmount.value)), 1), _cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "text-slate-300"
      }, "→", -1)), _cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "text-[10px] uppercase tracking-wide text-slate-400"
      }, "出", -1)), _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(formatInvoiceAmount)(outputAmount.value)), 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, [_cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "text-[10px] uppercase tracking-wide text-slate-400"
      }, "利率", -1)), _createElementVNode("span", {
        class: _normalizeClass(["ml-1 font-medium", isHundredPercent.value ? 'text-amber-700' : 'text-slate-700'])
      }, _toDisplayString(_unref(formatProfitRate)(profitRate.value)), 3)]), _cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "text-slate-300"
      }, "·", -1)), _createElementVNode("span", null, [_cache[10] || (_cache[10] = _createElementVNode("span", {
        class: "text-[10px] uppercase tracking-wide text-slate-400"
      }, "税", -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatInvoiceAmountTo)(taxAmount.value, 2)), 1)])]), _createElementVNode("div", _hoisted_20, [_cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "text-[10px] uppercase tracking-wide"
      }, "品名", -1)), _createElementVNode("span", {
        class: _normalizeClass(["ml-1", edgeProductUnmatched.value ? 'font-medium text-amber-700' : 'text-slate-500'])
      }, _toDisplayString(displayedEdgeProductName.value), 3), edgeProductUnmatched.value ? (_openBlock(), _createElementBlock("span", _hoisted_21, "品名未匹配")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lockChips.value, item => {
        return _withDirectives((_openBlock(), _createElementBlock("button", {
          key: item.key,
          type: "button",
          class: _normalizeClass(["lock-chip", item.locked ? 'is-locked' : 'is-unlocked']),
          disabled: __props.syncing,
          title: item.title,
          onClick: _withModifiers($event => emit('toggle-lock', item.key), ["stop"])
        }, [_createTextVNode(_toDisplayString(item.label), 1)], 10, _hoisted_23)), [[_directive_permission, 'enterprise-invoice:chain:lock']]);
      }), 128))])], 64))], 2);
    };
  }
};